module.exports = __webpack_public_path__ + "950a79d2da418aeefb943898852962d4.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/light.png
 ** module id = 1557
 ** module chunks = 0
 **/